module.exports = __webpack_public_path__ + "img/violet_054.bf2ab383.png";